const PETALS = ['💮', '✿', '🌸', '✾', '🌀'];

function SakuraOrbit({ label = 'Đang tải', size = 'md' }) {
    return (
        <div className={`sk-orbit-wrap sk-orbit-wrap--${size}`}>
            <div className="sk-orbit-scene">
                <div className="sk-orbit-ring" />
                <div className="sk-orbit-hub"><span>桜</span></div>
                {PETALS.map((p, i) => (
                    <div key={i} className="sk-orbit-arm" style={{ animationDelay: `${-(i * 0.4)}s` }}>
                        <span className="sk-orbit-petal">{p}</span>
                    </div>
                ))}
            </div>
            {label && (
                <p className="sk-orbit-label">
                    {label}<span className="sk-orbit-dots"><span>.</span><span>.</span><span>.</span></span>
                </p>
            )}
        </div>
    );
}

export default SakuraOrbit;
